export const BM_WIZARD_STEPS = [
  {
    id: 'login',
    label: 'Facebook',
    crumb: 'ACESSO',
    title: 'Entre com o Facebook',
    subtitle: 'Use o Facebook que administra a BM. Depois do login, você escolhe quais BMs importar.',
    hint: 'Permissão',
  },
];

export const FACEBOOK_PERMISSIONS = [
  { code: 'ads_read', required: true, description: 'Ler BMs, contas, campanhas e métricas.' },
  { code: 'ads_management', required: true, description: 'Pausar, ativar e mudar orçamento pelo painel.' },
  { code: 'business_management', required: true, description: 'Listar as Business Managers dessa conta.' },
];
